import { memo } from 'react';

export const ThreeSteps = memo(function ThreeSteps({ steps }) {
  return (
    <div className="container">
      {steps.map((step, index) => (
        <div className="step" key={index}>
          <h2 className="step__headline">
            <span className="step__number">{index + 1}.</span>
            {step.title}
          </h2>
          <p className="step__paragraph">{step.paragraph}</p>
        </div>
      ))}
      <style jsx>{`
        .container {
          position: relative;
          padding-left: 36px;
        }

        .container::before {
          content: '';
          left: 9px;
          top: 18px;
          bottom: 0;
          position: absolute;
          z-index: 1;
          width: 3px;
          background-color: var(--bgBlueish__tintedText);
        }

        .step__headline {
          position: relative;
          margin: 18px 0 9px 0;
          color: var(--bgBlueish__tintedText);
          font-weight: 700;
          font-size: 24px;
        }

        .step__headline::before {
          position: absolute;
          z-index: 2;
          left: -36px;
          top: 45%;
          content: '';
          display: block;
          width: 21px;
          height: 21px;
          border: solid 3px var(--bgBlueish__tintedText);
          border-radius: 50%;
          box-sizing: border-box;
          background-color: var(--bgBlueish);
        }

        .step__number {
          margin-right: 6px;
          font-size: 66px;
          line-height: 1;
          vertical-align: sub;
        }

        .step__paragraph {
          margin: 9px 0 18px 0;
          color: var(--bgBlueish__text);
          font-size: 20px;
          font-weight: 500;
          line-height: 1.4;
        }

        @media screen and (min-width: 750px) {
          .container {
            margin-bottom: 90px;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            padding-left: 0;
          }

          .container::before {
            top: auto;
            right: 0;
            bottom: 0;
            left: 0;
            width: auto;
            height: 3px;
            border-radius: 1px;
            z-index: 1;
          }

          .step {
            position: relative;
            padding: 54px 32px 54px 32px;
            border-right: solid 3px rgba(0, 0, 0, 0.04);
            box-sizing: border-box;
          }

          .step:last-child {
            border-right: none;
          }

          .step__headline {
            position: static;
            margin: 0 0 36px -16px;
          }

          .step__headline::before {
            left: 50%;
            transform: translateX(-50%);
            top: auto;
            bottom: -9px;
          }
        }

        @media (prefers-color-scheme: dark) {
          .step {
            border-right-color: rgba(255, 255, 255, 0.08);
          }
        }

        @media screen and (min-width: 1100px) {
          .step {
            padding: 90px 54px 90px 54px;
          }

          .step__headline {
            margin: 0 0 36px -32px;
          }

          .step__number {
            font-size: 72px;
          }

          .step__paragraph {
            line-height: 1.5;
            font-size: 22px;
          }
        }
      `}</style>
    </div>
  );
});
